
const stadiums = [
    {
      _id: "stadium1",
      name: "Lusail Iconic Stadium",
      country: "QA",
      city: "Lusail",
      capacity: 80000,
      wiki: "https://en.wikipedia.org/wiki/Lusail_Iconic_Stadium",
    },
    {
      _id: "stadium2",
      name: "Al-Bayt Stadium",
      country: "QA",
      city: "Al Khor",
      capacity: 60000,
      wiki: "https://en.wikipedia.org/wiki/Al_Bayt_Stadium",
    },
    {
      _id: "stadium3",
      name: "Stadium 974",
      country: "QA",
      city: "Doha",
      capacity: 40000,
      wiki: "https://en.wikipedia.org/wiki/Stadium_974",
    },
    {
      _id: "stadium4",
      name: "Al Thumama Stadium",
      country: "QA",
      city: "Doha",
      capacity: 40000,
      wiki: "https://en.wikipedia.org/wiki/Al_Thumama_Stadium",
    },
    {
      _id: "stadium5",
      name: "Education City Stadium",
      country: "QA",
      city: "Al Rayyan",
      capacity: 45350,
      wiki: "https://en.wikipedia.org/wiki/Education_City_Stadium",
    },
    {
      _id: "stadium6",
      name: "Ahmad bin Ali Stadium",
      country: "QA",
      city: "Al Rayyan",
      capacity: 44740,
      wiki: "https://en.wikipedia.org/wiki/Ahmad_bin_Ali_Stadium",
    },
    {
      _id: "stadium7",
      name: "Khalifa International Stadium",
      country: "QA",
      city: "Al Rayyan",
      capacity: 40000,
      wiki: "https://en.wikipedia.org/wiki/Khalifa_International_Stadium",
    },
    {
      _id: "stadium8",
      name: "Al Wakrah",
      country: "QA",
      city: "Al Janoub Stadium",
      capacity: 40000,
      wiki: "https://en.wikipedia.org/wiki/Al_Janoub_Stadium",
    }
]

export default stadiums